/**
 * メッセージ取得
 * @param   {string}   msg    メッセージテンプレート
 * @param   {string[]} params 置換文字列
 * @returns {string} メッセージ
 */
export const getMessage = (msg, ...params) => {
  let m = msg;
  for (let idx = 0; params.length > idx; idx += 1) {
    m = m.replace(`{${idx}}`, params[idx]);
  }
  return m;
};

/**
 * 単位変換
 * byte ⇒ kb、byte ⇒ mb
 * @param   {number} size サイズ（byte）
 * @returns {string} 単位付きサイズ
 */
export const convertSize = (size) => {
  const kb = 1000;
  const mb = kb ** 2;
  let s;
  if (size >= mb) {
    const n = (size / mb).toFixed(1);
    s = `${n}MB`;
  } else if (size >= kb) {
    const n = (size / kb).toFixed(1);
    s = `${n}KB`;
  } else {
    const n = size.toFixed(1);
    s = `${n}B`;
  }
  return s;
};
